import ShoppingListsListItem from './ShoppingListsListItem';

export default ShoppingListsListItem;
